// Transaction Helper for handling both MetaMask and Private Key transactions

export const sendContractTransaction = async (web3Context, method, options = {}) => {
  const {
    web3,
    account,
    connectionType,
    sendTransaction
  } = web3Context;

  if (!account || !web3) {
    throw new Error('Wallet not connected');
  }

  try {
    // For private key connections, use the sendTransaction helper
    if (connectionType === 'privatekey') {
      const txData = method.encodeABI();
      const gas = await method.estimateGas({ from: account, ...options });

      const txObject = {
        to: method._parent._address,
        data: txData,
        gas: gas,
        ...options
      };

      const receipt = await sendTransaction(txObject);
      return receipt;
    } else {
      // For MetaMask, use the standard send method
      const receipt = await method.send({ from: account, ...options });
      return receipt;
    }
  } catch (error) {
    console.error('Transaction failed:', error);
    throw error;
  }
};

// Helper to handle token approvals
export const approveToken = async (web3Context, tokenAddress, spenderAddress, amount) => {
  const { checkAndApproveToken } = web3Context;

  try {
    const result = await checkAndApproveToken(tokenAddress, spenderAddress, amount);
    return result;
  } catch (error) {
    console.error('Approval failed:', error);
    throw error;
  }
};

// Helper to estimate gas for transactions
export const estimateGas = async (web3Context, method, options = {}) => {
  const { account } = web3Context;

  try {
    const gas = await method.estimateGas({ from: account, ...options });
    return gas;
  } catch (error) {
    console.error('Gas estimation failed:', error);
    // Return a default gas limit if estimation fails
    return 200000;
  }
};

// Helper to format transaction error messages
export const formatTransactionError = (error) => {
  if (error.message) {
    if (error.message.includes('User denied')) {
      return 'Transaction cancelled by user';
    }
    if (error.message.includes('insufficient funds')) {
      return 'Insufficient funds for transaction';
    }
    if (error.message.includes('gas required exceeds')) {
      return 'Gas limit exceeded';
    }
    if (error.message.includes('nonce too low')) {
      return 'Transaction nonce error - please try again';
    }
  }

  return error.message || 'Transaction failed';
};